import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
declare var $: any;
@Component({
  selector: 'app-modal-manager',
  templateUrl: './modal-manager.component.html',
  styleUrls: ['./modal-manager.component.css']
})
export class ModalManagerComponent implements OnInit {
  constructor(
    public bsModalRef: BsModalRef
  ) { }
  user: any;
  manager_type: any = 'customer';
  closeBtnName: any;
  ngOnInit() {
    //console.log(this.user);

  }

  manager(type) {
    this.manager_type = type;
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/modal-manager/modal-manager.component.ts